export enum Permissions {
  addActualShipment = 'add_actualshipment',
  addPrice = 'add_price',
  deletePrice = 'delete_price',
  addTarget = 'add_target',
  deleteTarget = 'delete_target',
  addDataSourceVersion = 'add_datasourceversion',
  canViewDataStatuses = 'can_view_data_statuses',
  viewDataSources = 'view_datasource',
  deleteActualShipment = 'delete_actualshipment',
  deleteDataSourceVersion = 'delete_datasourceversion',
  sendForCalculationForecast = 'send_for_calculation_forecastscenarioresult',
  canDownloadForecastExcel = 'can_download_forecast_excel',
  viewForecastScenario = 'view_forecastscenario',
  viewForecastScenarioResult = 'view_forecastscenarioresult',
  changeForecastScenario = 'change_forecastscenario',
  addForecastScenario = 'add_forecastscenario',
  deleteForecastScenario = 'delete_forecastscenario',
  setIsProposedForecast = 'set_is_proposed_forecastscenario',
  // архивирование закрыто **отдельным** правом на бэкенде (§5 M7): у права на правку
  // сценария и права убирать его со стола разные владельцы
  setIsArchivedForecastScenario = 'set_is_archived_forecastscenario',
  canEditMasterData = 'can_edit_masterdata',
  canDeletePromoScenario = 'delete_promoscenario',
  canChangePromoScenario = 'change_promoscenario',
  canDeleteReplenScenario = 'delete_replenscenario',
  canSetDefaultWidgetsOrder = 'can_set_default_widgets_order',
  canDeleteRtmScenario = 'delete_rtmscenario',
  canChangeRtmScenario = 'change_rtmscenario',
  canDeleteTetrisScenario = 'delete_tetrisscenario',
  canChangeTetrisScenario = 'change_tetrisscenario',
  canDeleteCfrScenario = 'delete_cfrscenario',
  canChangeCfrScenario = 'change_cfrscenario',
  viewEditForecastDashboard = 'view_edit_forecast_dashboard',
  viewScenarioLoad = 'view_scenarioload',
  changeScenarioLoad = 'change_scenarioload',
  viewScenarioCalcVersion = 'view_scenariocalcversion',
  changeScenarioCalcVersion = 'change_scenariocalcversion',
  viewScenarioQuality = 'view_scenarioquality',
  changeScenarioQualitySettings = 'change_scenarioquality_settings',
}
